/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Olive_Teal_Ram_MeltInputs */

const en_olive_teal_ram_melt = /** @type {(inputs: Olive_Teal_Ram_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS message`)
};

const de_olive_teal_ram_melt = /** @type {(inputs: Olive_Teal_Ram_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS-Nachricht`)
};

/**
* | output |
* | --- |
* | "SMS message" |
*
* @param {Olive_Teal_Ram_MeltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const olive_teal_ram_melt = /** @type {((inputs?: Olive_Teal_Ram_MeltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Olive_Teal_Ram_MeltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_olive_teal_ram_melt(inputs)
	return de_olive_teal_ram_melt(inputs)
});